import {Component} from '@angular/core';

@Component({
  selector: 'answer-node',
  templateUrl: './answer-node.component.html'
})
export class AnswerNodeComponent {
    node
}
